module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"toggle":"Toggle navigation"},"analyticsNotice":"Help improve Central!"}}')
  delete Component.options._Ctor
}
